import { store } from "../lib/store.js";
import { formatRelativeTime, formatPercent } from "../utils/format.js";

export function mountFooter(root) {
  root.innerHTML = `
    <footer class="status-footer" role="contentinfo">
      <span class="status-indicator" data-status></span>
      <span class="status-updated" data-updated></span>
      <span
        class="status-uptime"
        data-uptime
        title="Baseado em heartbeats de /api/metrics enquanto o Dashboard está aberto — não é uptime de infra 24/7 independente disso. Ver design.md."
      >Uptime: —</span>
    </footer>
  `;

  const indicator = root.querySelector("[data-status]");
  const updated = root.querySelector("[data-updated]");
  const uptimeEl = root.querySelector("[data-uptime]");

  function render() {
    const alerts = store.systemAlerts.get();
    const hasCritical = alerts.some((a) => a.severity === "P0" || a.severity === "critical");
    const hasAny = alerts.length > 0;

    if (hasCritical) {
      indicator.textContent = "🔴 Incidente ativo";
      indicator.className = "status-indicator status-indicator--error";
    } else if (hasAny) {
      indicator.textContent = "🟡 Alertas leves";
      indicator.className = "status-indicator status-indicator--warning";
    } else {
      indicator.textContent = "🟢 Todos os sistemas OK";
      indicator.className = "status-indicator status-indicator--ok";
    }

    const lastEvent = store.realtimeStatus.get().lastEventAt;
    updated.textContent = `Última atualização: ${lastEvent ? formatRelativeTime(new Date(lastEvent).toISOString()) : "—"}`;
  }

  const unsubscribeAlerts = store.systemAlerts.subscribe(render);
  const unsubscribeRealtime = store.realtimeStatus.subscribe(render);
  const unsubscribeMetrics = store.metrics.subscribe((metrics) => {
    uptimeEl.textContent = `Uptime: ${metrics?.uptimePercent30d != null ? `${formatPercent(metrics.uptimePercent30d)} (30 dias)` : "—"}`;
  });
  const intervalId = setInterval(render, 5000);

  return () => {
    unsubscribeAlerts();
    unsubscribeRealtime();
    unsubscribeMetrics();
    clearInterval(intervalId);
    root.innerHTML = "";
  };
}
